import { toast } from "react-toastify";

export function successToast(message, options = {}) {
  toast.success(message, {
    position: options.position || "top-right",
    autoClose: options.autoClose || 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    style: {
      background: "#232625",
      color: "#fff",
      padding: "16px 16px",
      minWidth: "400px",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
      fontSize: "16px"
    },
    ...options
  });
}

export function errorToast(message, options = {}) {
  toast.error(message, {
    position: options.position || "top-right",
    autoClose: options.autoClose || 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    style: {
      background: "#d62409",
      color: "#fff",
      padding: "16px 16px",
      minWidth: "400px",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
      fontSize: "16px"
    },
    ...options
  });
}
export function warningToast(message, ...rest) {
  toast.warning(message);
}
